/*
==========================================================
GLIA COMMERCE ENGINE
Run For Palestine Donation Mode
==========================================================
*/

class GliaCommerce {

    constructor(config) {

        this.config = config;

        this.products = {
            donation: null,
            monthly: null
        };

        this.selection = {
            donation: null,
            monthly: null
        };

        this.customDonationVariant = null;
        this.customMonthlyVariant = null;

        this.initialize();
    }


    /*
    ======================================================
    INITIALIZE
    ======================================================
    */

    async initialize() {

        try {

            await this.loadProducts();

            this.renderDonations();
            this.renderMonthly();

            this.bindDonationToggle();
            this.bindDonationButtons();
            this.bindMonthlyButtons();
            this.bindDonateButton();

            console.log(
                "Glia Commerce: Run For Palestine donation engine ready."
            );

        } catch (error) {

            console.error(
                "Glia Commerce initialization failed:",
                error
            );
        }
    }


    /*
    ======================================================
    LOAD PRODUCTS
    ======================================================
    */

    async loadProducts() {

        const handles =
            this.config.products;

        this.products.donation =
            await this.fetchProduct(
                handles.donation
            );

        this.products.monthly =
            await this.fetchProduct(
                handles.monthly
            );

        console.log(
            "Glia Commerce products loaded:",
            this.products
        );
    }


    /*
    ======================================================
    FIND VARIANT
    ======================================================
    */

    getVariant(
        product,
        variantId
    ) {

        if (!product) {
            return null;
        }

        return (
            product.variants || []
        ).find(
            variant =>
                Number(variant.id) ===
                Number(variantId)
        ) || null;
    }


    /*
    ======================================================
    GET SELLING PLAN
    ======================================================
    */

    getSellingPlanId(
        variant
    ) {

        if (!variant) {
            return null;
        }


        const allocations =
            variant.selling_plan_allocations || [];


        if (!allocations.length) {
            return null;
        }


        /*
        Use the selling plan configured
        for this specific variant.
        */

        return Number(
            allocations[0].selling_plan_id
        );
    }


    /*
    ======================================================
    ONE-TIME DONATIONS
    ======================================================
    */

    renderDonations() {

        const container =
            document.getElementById(
                "glia-donation-list"
            );

        if (
            !container ||
            !this.products.donation
        ) {
            return;
        }

        container.innerHTML = "";

        const variants =
            this.products.donation.variants || [];

        const allowedAmounts = [
            25,
            50,
            100,
            250,
            500,
            1000
        ];


        /*
        STANDARD ONE-TIME AMOUNTS
        */

        variants.forEach(
            variant => {

                const price =
                    Number(
                        variant.price
                    ) / 100;

                const title =
                    String(
                        variant.title || ""
                    ).toLowerCase();


                if (
                    title.includes("custom")
                ) {
                    return;
                }


                if (
                    !allowedAmounts.includes(
                        price
                    )
                ) {
                    return;
                }


                container.insertAdjacentHTML(
                    "beforeend",
                    `
                    <label class="glia-donation-card">

                        <input
                            type="radio"
                            name="glia-donation"
                            value="${variant.id}"
                            data-price="${variant.price}">

                        <span class="glia-donation-card__amount">
                            $${price.toFixed(0)}
                        </span>

                    </label>
                    `
                );

            }
        );


        /*
        CUSTOM ONE-TIME AMOUNT
        */

        this.customDonationVariant =
            variants.find(
                variant => {

                    const title =
                        String(
                            variant.title || ""
                        ).toLowerCase();

                    return title.includes(
                        "custom"
                    );

                }
            ) || null;


        if (
            this.customDonationVariant
        ) {

            container.insertAdjacentHTML(
                "beforeend",
                `
                <label class="glia-custom-card">

                    <input
                        type="number"
                        id="glia-custom-donation"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        placeholder="Other amount">

                </label>
                `
            );

            this.bindCustomDonation();
        }
    }


    /*
    ======================================================
    ONE-TIME BUTTONS
    ======================================================
    */

    bindDonationButtons() {

        document
            .querySelectorAll(
                'input[name="glia-donation"]'
            )
            .forEach(
                input => {

                    input.addEventListener(
                        "change",
                        () => {

                            const custom =
                                document.getElementById(
                                    "glia-custom-donation"
                                );


                            if (custom) {
                                custom.value = "";
                            }


                            /*
                            Do NOT touch monthly.
                            Both can be selected.
                            */

                            this.selection.donation = {

                                id:
                                    Number(
                                        input.value
                                    ),

                                quantity:
                                    1,

                                amount:
                                    Number(
                                        input.dataset.price
                                    )

                            };


                            this.updateTotal();

                        }
                    );

                }
            );
    }


    /*
    ======================================================
    CUSTOM ONE-TIME
    ======================================================
    */

    bindCustomDonation() {

        const input =
            document.getElementById(
                "glia-custom-donation"
            );

        if (!input) {
            return;
        }


        input.addEventListener(
            "input",
            () => {

                const amount =
                    parseInt(
                        input.value,
                        10
                    ) || 0;


                /*
                Clear standard one-time
                buttons only.
                */

                document
                    .querySelectorAll(
                        'input[name="glia-donation"]'
                    )
                    .forEach(
                        radio => {
                            radio.checked = false;
                        }
                    );


                /*
                Do NOT touch monthly.
                */

                if (
                    amount > 0 &&
                    this.customDonationVariant
                ) {

                    this.selection.donation = {

                        id:
                            Number(
                                this.customDonationVariant.id
                            ),

                        /*
                        $1 variant × quantity
                        */

                        quantity:
                            amount,

                        amount:
                            amount * 100

                    };

                } else {

                    this.selection.donation =
                        null;

                }


                this.updateTotal();

            }
        );
    }


    /*
    ======================================================
    MONTHLY DONATIONS
    ======================================================
    */

    renderMonthly() {

        const container =
            document.getElementById(
                "glia-monthly-list"
            );

        if (
            !container ||
            !this.products.monthly
        ) {
            return;
        }

        container.innerHTML = "";

        const variants =
            this.products.monthly.variants || [];

        const allowedAmounts = [
            25,
            50,
            100,
            250,
            500,
            1000
        ];


        /*
        STANDARD MONTHLY AMOUNTS
        */

        variants.forEach(
            variant => {

                const price =
                    Number(
                        variant.price
                    ) / 100;

                const title =
                    String(
                        variant.title || ""
                    ).toLowerCase();


                if (
                    title.includes("custom")
                ) {
                    return;
                }


                if (
                    !allowedAmounts.includes(
                        price
                    )
                ) {
                    return;
                }


                container.insertAdjacentHTML(
                    "beforeend",
                    `
                    <label class="glia-donation-card">

                        <input
                            type="radio"
                            name="glia-monthly"
                            value="${variant.id}"
                            data-price="${variant.price}">

                        <span class="glia-donation-card__amount">
                            $${price.toFixed(0)}<small>/mo</small>
                        </span>

                    </label>
                    `
                );

            }
        );


        /*
        CUSTOM MONTHLY AMOUNT
        */

        this.customMonthlyVariant =
            variants.find(
                variant => {

                    const title =
                        String(
                            variant.title || ""
                        ).toLowerCase();

                    return title.includes(
                        "custom"
                    );

                }
            ) || null;


        if (
            this.customMonthlyVariant
        ) {

            container.insertAdjacentHTML(
                "beforeend",
                `
                <label class="glia-custom-card">

                    <input
                        type="number"
                        id="glia-custom-monthly"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        placeholder="Other amount">

                </label>
                `
            );

            this.bindCustomMonthly();
        }
    }


    /*
    ======================================================
    MONTHLY BUTTONS
    ======================================================
    */

    bindMonthlyButtons() {

        document
            .querySelectorAll(
                'input[name="glia-monthly"]'
            )
            .forEach(
                input => {

                    input.addEventListener(
                        "change",
                        () => {

                            const custom =
                                document.getElementById(
                                    "glia-custom-monthly"
                                );


                            if (custom) {
                                custom.value = "";
                            }


                            /*
                            Find the actual variant.
                            */

                            const variant =
                                this.getVariant(
                                    this.products.monthly,
                                    input.value
                                );


                            /*
                            Get the selling plan
                            configured for that variant.
                            */

                            const sellingPlanId =
                                this.getSellingPlanId(
                                    variant
                                );


                            this.selection.monthly = {

                                id:
                                    Number(
                                        input.value
                                    ),

                                quantity:
                                    1,

                                amount:
                                    Number(
                                        input.dataset.price
                                    ),

                                sellingPlanId:
                                    sellingPlanId

                            };


                            this.updateTotal();

                        }
                    );

                }
            );
    }


    /*
    ======================================================
    CUSTOM MONTHLY
    ======================================================
    */

    bindCustomMonthly() {

        const input =
            document.getElementById(
                "glia-custom-monthly"
            );

        if (!input) {
            return;
        }


        input.addEventListener(
            "input",
            () => {

                const amount =
                    parseInt(
                        input.value,
                        10
                    ) || 0;


                /*
                Clear standard monthly
                buttons only.
                */

                document
                    .querySelectorAll(
                        'input[name="glia-monthly"]'
                    )
                    .forEach(
                        radio => {
                            radio.checked = false;
                        }
                    );


                /*
                Do NOT touch one-time.
                */

                if (
                    amount > 0 &&
                    this.customMonthlyVariant
                ) {

                    const sellingPlanId =
                        this.getSellingPlanId(
                            this.customMonthlyVariant
                        );


                    this.selection.monthly = {

                        id:
                            Number(
                                this.customMonthlyVariant.id
                            ),

                        /*
                        $1 variant × quantity.
                        */

                        quantity:
                            amount,

                        amount:
                            amount * 100,

                        sellingPlanId:
                            sellingPlanId

                    };

                } else {

                    this.selection.monthly =
                        null;

                }


                this.updateTotal();

            }
        );
    }


    /*
    ======================================================
    ONE-TIME ACCORDION
    ======================================================
    */

    bindDonationToggle() {

        const button =
            document.getElementById(
                "glia-donation-toggle"
            );

        const panel =
            document.getElementById(
                "glia-donation-content"
            );

        if (
            !button ||
            !panel
        ) {
            return;
        }


        button.addEventListener(
            "click",
            () => {

                const isOpen =
                    panel.style.display ===
                    "block";


                panel.style.display =
                    isOpen
                        ? "none"
                        : "block";


                button.setAttribute(
                    "aria-expanded",
                    String(!isOpen)
                );


                const symbol =
                    button.querySelector(
                        "span:last-child"
                    );


                if (symbol) {

                    symbol.textContent =
                        isOpen
                            ? "+"
                            : "−";

                }

            }
        );
    }


    /*
    ======================================================
    TOTAL
    ======================================================
    */

    updateTotal() {

        let total = 0;


        if (
            this.selection.donation
        ) {

            total +=
                this.selection.donation.amount /
                100;

        }


        if (
            this.selection.monthly
        ) {

            total +=
                this.selection.monthly.amount /
                100;

        }


        const totalElement =
            document.getElementById(
                "glia-total"
            );


        if (totalElement) {

            totalElement.textContent =
                `$${total.toFixed(2)} CAD`;

        }
    }


    /*
    ======================================================
    DONATE BUTTON
    ======================================================
    */

    bindDonateButton() {

        const button =
            document.getElementById(
                "reserve-seats"
            );

        if (!button) {
            return;
        }


        button.addEventListener(
            "click",
            () => {

                this.submitDonation(
                    button
                );

            }
        );
    }


    /*
    ======================================================
    SUBMIT DONATION
    ======================================================
    */

    async submitDonation(
        button
    ) {

        const items = [];


        /*
        --------------------------------------------------
        ONE-TIME
        --------------------------------------------------
        */

        if (
            this.selection.donation
        ) {

            items.push({

                id:
                    this.selection.donation.id,

                quantity:
                    this.selection.donation.quantity,

                properties: {

                    Event:
                        this.config.campaign,

                    "Donor Type":
                        "One-Time"

                }

            });

        }


        /*
        --------------------------------------------------
        MONTHLY
        --------------------------------------------------
        */

        if (
            this.selection.monthly
        ) {

            const monthlyItem = {

                id:
                    this.selection.monthly.id,

                quantity:
                    this.selection.monthly.quantity,

                properties: {

                    Event:
                        this.config.campaign,

                    "Donor Type":
                        "Monthly"

                }

            };


            /*
            Apply the selling plan only
            to the monthly line.

            This is what makes the line
            recurring in Shopify.
            */

            if (
                this.selection.monthly.sellingPlanId
            ) {

                monthlyItem.selling_plan =
                    this.selection.monthly.sellingPlanId;

            } else {

                console.warn(
                    "No selling plan found for monthly donation variant."
                );

            }


            items.push(
                monthlyItem
            );
        }


        /*
        --------------------------------------------------
        NOTHING SELECTED
        --------------------------------------------------
        */

        if (
            !items.length
        ) {

            alert(
                "Please select a donation amount."
            );

            return;
        }


        console.log(
            "Run For Palestine cart items:",
            items
        );


        /*
        --------------------------------------------------
        SUBMIT
        --------------------------------------------------
        */

        button.disabled = true;

        button.textContent =
            "Processing...";


        try {

            const response =
                await fetch(
                    window.Shopify.routes.root +
                    "cart/add.js",
                    {

                        method:
                            "POST",

                        headers: {

                            "Content-Type":
                                "application/json"

                        },

                        body:
                            JSON.stringify({
                                items:
                                    items
                            })

                    }
                );


            if (!response.ok) {

                const errorText =
                    await response.text();

                console.error(
                    "Shopify cart error:",
                    errorText
                );

                throw new Error(
                    errorText
                );
            }


            /*
            Success.
            */

            window.location.href =
                "/cart";


        } catch (error) {

            console.error(
                "Glia Commerce donation error:",
                error
            );


            alert(
                "Unable to add your donation to the cart.\n\n" +
                "Please try again."
            );


            button.disabled = false;

            button.textContent =
                "Donate Now";

        }
    }


    /*
    ======================================================
    PRODUCT FETCH
    ======================================================
    */

    async fetchProduct(
        handle
    ) {

        if (!handle) {
            return null;
        }


        try {

            const response =
                await fetch(
                    `/products/${handle}.js`
                );


            if (!response.ok) {

                throw new Error(
                    `Unable to load product: ${handle}`
                );

            }


            return await response.json();


        } catch (error) {

            console.error(
                "Glia Commerce product error:",
                error
            );

            return null;
        }
    }
}


/*
==========================================================
START ENGINE
==========================================================
*/

document.addEventListener(
    "DOMContentLoaded",
    () => {

        if (
            !window.Glia?.Commerce
        ) {

            console.error(
                "Glia Commerce configuration not found."
            );

            return;
        }


        window.Glia.Commerce.Engine =
            new GliaCommerce(
                window.Glia.Commerce
            );

    }
);